import { render, staticRenderFns } from "./inviteFriend.vue?vue&type=template&id=ecadbfcc&scoped=true&"
import script from "./inviteFriend.vue?vue&type=script&lang=js&"
export * from "./inviteFriend.vue?vue&type=script&lang=js&"
import style0 from "./inviteFriend.vue?vue&type=style&index=0&id=ecadbfcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecadbfcc",
  null
  
)

export default component.exports